import {
    Component,
    Input,
    OnDestroy,
    AfterViewInit,
    ElementRef,
    ViewChild,
    NgZone,
} from '@angular/core';
import { Coordinates } from '../../models/coordinates.model';
import * as L from 'leaflet';

const iconDefault = L.icon({
    iconUrl: 'assets/map/location.png',
    iconSize: [40, 40]
});

@Component({
    selector: 'app-map-preview',
    standalone: true,
    template: `<div #mapContainer class="map-container"></div>`,
    styles: [`
    :host {
      display: block;
      width: 100%;
      height: 220px;
      position: relative;
      z-index: 1;
    }
    .map-container {
      width: 100%;
      height: 100%;
      border-radius: 14px;
      overflow: hidden;
    }
  `],
})
export class MapPreview implements AfterViewInit, OnDestroy {
    @Input() coordinates: Coordinates | null | undefined = null;
    @Input() name: string = '';

    @ViewChild('mapContainer') mapContainer!: ElementRef;

    private map?: L.Map;
    private resizeObserver?: ResizeObserver;

    constructor(private zone: NgZone) { }

    ngAfterViewInit() {
        // Wait until the container actually has positive dimensions
        this.resizeObserver = new ResizeObserver((entries) => {
            const entry = entries[0];
            const { width, height } = entry.contentRect;
            if (width > 0 && height > 0 && !this.map && this.coordinates) {
                this.resizeObserver?.disconnect();
                this.zone.runOutsideAngular(() => {
                    this.initMap();
                });
            }
        });
        this.resizeObserver.observe(this.mapContainer.nativeElement);
    }

    private initMap() {
        const { latitude: lat, longitude: lng } = this.coordinates!;

        this.map = L.map(this.mapContainer.nativeElement, {
            center: [lat, lng],
            zoom: 16,
            zoomControl: false,
            attributionControl: false,
            dragging: false,
            scrollWheelZoom: false,
            doubleClickZoom: false,
            touchZoom: false,
        });

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
        }).addTo(this.map);

        L.marker([lat, lng], { icon: iconDefault }).addTo(this.map);

        this.map.invalidateSize();
    }

    private destroyMap() {
        this.resizeObserver?.disconnect();
        if (this.map) {
            this.map.remove();
            this.map = undefined;
        }
    }

    ngOnDestroy() {
        this.destroyMap();
    }
}

